import React from 'react';
import { Helmet } from 'react-helmet-async';

const NotebookSEO = ({ title, description, image }) => {
    const siteTitle = "sciFi";
    const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
    const defaultDescription = "View and run this interactive Jupyter notebook.";
    const metaDescription = description || defaultDescription;
    const currentUrl = window.location.href;

    return (
        <Helmet>
            {/* Basic */}
            <title>{fullTitle}</title>
            <meta name="description" content={metaDescription} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="article" />
            <meta property="og:url" content={currentUrl} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={metaDescription} />
            {image && <meta property="og:image" content={image} />}

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={currentUrl} />
            <meta property="twitter:title" content={fullTitle} />
            <meta property="twitter:description" content={metaDescription} />
            {image && <meta property="twitter:image" content={image} />}
        </Helmet>
    );
};

export default NotebookSEO;
